(function () {
    'use strict';

    var directiveName = 'hmClick';
    angular.module('aprima-core-ui').directive(directiveName, [
        'ClickListenerService',
        hmClick
    ]);

    function hmClick(
        ClickListenerService
    ) {
        return {
            restrict: 'A',
            link: link,
        };

        function link(scope, element, attrs) {
            ClickListenerService.registerFromDirective(scope, element, attrs, directiveName);
        }
    }
})();
